export const numericHint = (decimalMarker: string): ((value: string) => string | null) => {
    return (value: string): string | null => {
        const isValidCharacter = new RegExp(`[\\d\\${decimalMarker}]`).test(value) || !value;
        return !isValidCharacter ? `Please provide valid format of numbers and a "${decimalMarker}"` : null;
    };
};
